module.exports = __webpack_public_path__ + "assets/img/Infographics1.7fad9712.png";